import type { AutoScrollOptions } from '@dnd-kit/core';

export const calendarAutoScrollOptions: AutoScrollOptions = {
  acceleration: 3,
  interval: 16,
  threshold: { x: 0.12, y: 0.12 },
};
